// extracted by mini-css-extract-plugin
export default {"element":"StoreSelectorOption__element___SsRNH"};